import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TEAM } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { TEAM_API } from '../../utils/apiUrl';

export const teamGetAllAction = createAsyncThunk(
  TEAM.GET_ALL,
  async (_, { rejectWithValue }) => {
    try {
      const data = await Get(TEAM_API.BASE, null, null);
      if (!data) return rejectWithValue('Không lấy được danh sách Team');
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const teamCreateAction = createAsyncThunk(
  TEAM.CREATE,
  async (model, { rejectWithValue }) => {
    try {
      const res = await Post(TEAM_API.CREATE, null, model, false);

      if (res && typeof res.status === 'number') {
        if (res.status === 200 || res.status === 201) {
          let body = null;
          try {
            body = await res.json(); 
          } catch (e) {
            // body rỗng thì thôi
          }
          return body || model;
        }

        let errBody = null;
        try {
          errBody = await res.json(); 
        } catch (e) {
          // không đọc được thì dùng message chung
        }
        return rejectWithValue(errBody || 'Tạo Team thất bại');
      }

      if (!res) return rejectWithValue('Tạo Team thất bại');
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const teamUpdateAction = createAsyncThunk(
  TEAM.UPDATE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await Put(TEAM_API.UPDATE, id, data);

      if (res && typeof res.status === 'number') {
        if (res.status >= 200 && res.status < 300) {
          return { id, ...data };
        }

        let errBody = null;
        try {
          errBody = await res.json();
        } catch (e) {
          // body rỗng / stream đã đọc thì bỏ qua
        }
        return rejectWithValue(errBody || 'Cập nhật Team thất bại');
      }

      if (!res) {
        return rejectWithValue('Cập nhật Team thất bại');
      }

      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const teamDeleteAction = createAsyncThunk(
  TEAM.DELETE,
  async (id, { rejectWithValue }) => {
    try {
      const res = await DeleteSingle(TEAM_API.DELETE, id, null);

      if (res && typeof res.status === 'number') {
        if (res.status === 200 || res.status === 204) {
          return id;
        }

        let errBody = null;
        try {
          errBody = await res.json();
        } catch (e) {
          // không đọc được body thì dùng message chung
        }
        return rejectWithValue(errBody || 'Xoá Team thất bại');
      }

      if (!res) return rejectWithValue('Xoá Team thất bại');
      return res;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  list: [],
  loading: false,
  error: null
};

export const teamSlice = createSlice({
  name: TEAM.NAME_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(teamGetAllAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(teamGetAllAction.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(teamGetAllAction.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload ||
          (action.error && action.error.message) ||
          'Lỗi khi tải danh sách Team';
      })

      .addCase(teamCreateAction.fulfilled, (state, action) => {
        if (action.payload) {
          state.list.push(action.payload);
        }
      })
      .addCase(teamCreateAction.rejected, (state, action) => {
        state.error =
          action.payload ||
          (action.error && action.error.message) ||
          'Tạo Team thất bại';
      })

      .addCase(teamUpdateAction.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated) return;
        const idx = state.list.findIndex((x) => x.id === updated.id);
        if (idx >= 0) {
          state.list[idx] = { ...state.list[idx], ...updated };
        }
      })
      .addCase(teamUpdateAction.rejected, (state, action) => {
        state.error =
          action.payload ||
          (action.error && action.error.message) ||
          'Cập nhật Team thất bại';
      })

      .addCase(teamDeleteAction.fulfilled, (state, action) => {
        const id = action.payload;
        state.list = state.list.filter((x) => x.id !== id);
      })
      .addCase(teamDeleteAction.rejected, (state, action) => {
        state.error =
          action.payload ||
          (action.error && action.error.message) ||
          'Xoá Team thất bại';
      });
  }
});

export default teamSlice.reducer;
